import { styled } from '@mui/material'
import { HorizontalTabs } from '../../eid-ui'

import Tab from './SlantedTab'

const SlantedTabs = styled(HorizontalTabs)({
    '& .MuiTabs-flexContainer': {
        paddingLeft: '15px',
        height: '50px',
    },
    '& .Mui-selected': {
        backgroundColor: '#ffffff',
        color: '#0057A0',
        '& svg': {
            color: '#0057A0',
        },
    },
    '& .MuiTabs-indicator': {
        display: 'none',
    },
    '& .MuiTab-labelIcon': { minHeight: '0px' },
})

SlantedTabs.Tab = Tab

export default SlantedTabs
